import Component from "flarum/common/Component";
import {urls} from "@speareducation/util";
import {getJwtCookie} from "@speareducation/util/auth";
import Tooltip from "flarum/common/components/Tooltip";

export default class AwayMessageSelector extends Component {
  state = {
    messageType: 'Available',
    expiresType: '30mins',
    myAwayMessage: [],
    otherAwayMessages: '',
    awayMessageTooltips: '',
    customDate: `${new Date().toISOString().substring(0, 10)} ${this.getDefaultTime()}`,
    isLoaded: false,
    futureError: null,
  }

  oninit(vnode) {
    super.oninit(vnode);
    document.addEventListener('onConversationSelected', this.onConversationSelected.bind(this));
    this.refreshCurrentAwayMessage();
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  async onConversationSelected(e) {
    if (e.detail.conversation == null) {
      // inbox loaded with no conversation
      return;
    }
    const {others} = e.detail.conversation;
    if (!(others && others.length)) {
      // No users in current chat
      return;
    }
    const ids = others.map(other => other.id).join(',');

    const jwt = getJwtCookie();

    $('AwayMessageSelector_header_left').addClass('mobile-hidden');

    try {
      const response = await fetch(urls.getBaseUrl('accounts') + `/api/v2/away-messages?ids=${encodeURIComponent(ids)}`,
        {
          headers: {
            'Authorization': `Bearer ${jwt}`,
          }
        });
      const data = Object.values(await response.json());

      switch (data.length) {
        case 0:
          // do nothing
          console.log('No presence info for specified user list');
          this.state.otherAwayMessages = '';
          this.state.awayMessageTooltips = [];
          m.redraw();
          break;
        case 1:
          // show the name of the person who is away
          const message = data[0];
          const displayName = message.display_name;
          const awayType = this.getAwayTypeLabel(message);

          try {
            const returnTimestamp = this.getFormattedReturnTimestamp(message.expires);
            this.state.otherAwayMessages = <div><b>{displayName}</b> is {awayType} and may not respond.</div>;
            this.state.awayMessageTooltips = [`${displayName} is '${awayType}' and will be available after ${returnTimestamp}`];
            m.redraw();
          } catch (e) {
            // ignore errors from date parsing
          }
          break;
        default:
          // Aggregate presence info and show "<b>N Members</b> are away and may not respond."
          const statusCount = data.length;
          this.state.otherAwayMessages = <div><b>{statusCount} Members</b> are away and may not respond.</div>
          this.state.awayMessageTooltips = [];
          // assemble tooltip
          data.forEach((item) => {
            try {
              const returnTimestamp = this.getFormattedReturnTimestamp(item.expires);
              const awayType = this.getAwayTypeLabel(item);
              const displayName = item.display_name;
              this.state.awayMessageTooltips.push(`${displayName} is '${awayType}' and will be available after ${returnTimestamp}`);
            } catch (e) {
              // ignore errors from date parsing
            }
          });
          m.redraw();

      }

    } catch (error) {
      console.error('Error:' + error);
    }
  }

  getAwayTypeLabel(message) {
    switch (message.message_type) {
      case 'away':
        return 'Away';
      case 'outofoffice':
        return 'Out of Office';
      case 'vacation':
        return 'On Vacation';
      default:
        // unknown status
        return;
    }
  }

  getFormattedReturnTimestamp(dateTime) {
    const date = new Date(dateTime);
    const optionsDate = {weekday: 'short', month: 'short', day: 'numeric'};
    const optionsTime = {hour: 'numeric', minute: 'numeric'};

    const formattedDate = new Intl.DateTimeFormat('en-US', optionsDate).format(date);
    const formattedTime = new Intl.DateTimeFormat('en-US', optionsTime).format(date);

    const day = date.getDate();
    let ordinalIndicator;
    if ([11, 12, 13].includes(day % 100)) {
      ordinalIndicator = 'th';
    } else {
      switch (day % 10) {
        case 1:
          ordinalIndicator = 'st';
          break;
        case 2:
          ordinalIndicator = 'nd';
          break;
        case 3:
          ordinalIndicator = 'rd';
          break;
        default:
          ordinalIndicator = 'th';
      }
    }

    return `${formattedDate + ordinalIndicator} at ${formattedTime}`;
  }

  view(vnode) {
    let messageType;
    switch (this.state.messageType) {
      case 'away':
        messageType = 'Away';
        break;
      case 'outofoffice':
        messageType = 'Out of Office';
        break;
      case 'vacation':
        messageType = 'Vacation';
        break;
      default:
        messageType = 'Available';
    }

    const todaysDate = new Date().toISOString().slice(0, -8);
    let customError = 'error ' + (this.state.futureError ? 'visible' : 'hidden');

    return <div class="AwayMessageSelector">
      <div class="AwayMessageSelector_header">
        <div class="AwayMessageSelector_header_left">
          <h4>
            <div class="icon fa-solid fa-envelope"></div>
            My Messages
          </h4>
        </div>
        <div class="AwayMessageSelector_header_right">
          <div id="AwayMessageSelector_participant_messages">
            {this.state.otherAwayMessages ?
              <div class="AwayMessageSelector_presence" onmouseover={this.enableTooltipIcon.bind(this)}
                   onmouseout={this.disableTooltipIcon.bind(this)}>
                <Tooltip text={this.state.awayMessageTooltips.join('<br/>')} html="true" position="bottom"
                         data-bs-custom-class="awaymessage-tooltip"
                >
                  <div style="display:flex;">
                    <div class="fa-regular fa-calendar-xmark icon"></div>
                    <div>{this.state.otherAwayMessages}</div>
                    <div id="AwayMessageSelector_regularIcon" class="fa-regular fa-info-circle info-icon"></div>
                    <div id="AwayMessageSelector_solidIcon" class="fa-solid fa-info-circle info-icon"
                         style="display:none;"></div>
                  </div>
                </Tooltip>
              </div> : ''}
          </div>
          <div onclick={this.toggleModal.bind(this)} class="AwayMessageSelector_statusList" style={!this.state.isLoaded ? 'display:none;' : ''}>
            <div class="AwayMessageSelector_statusList_inner">
              <div id="AwayMessageSelector_statusList_icon_available"
                   class="AwayMessageSelector_statusList_icon fa-solid fa-circle-check available-indicator" style="display:none;"></div>
              <div id="AwayMessageSelector_statusList_icon_away"
                   class="AwayMessageSelector_statusList_icon fa-solid fa-clock away-indicator" style="display:none;"></div>
              <div id="AwayMessageSelector_statusList_icon_outofoffice"
                   class="AwayMessageSelector_statusList_icon fa-solid fa-calendar outofoffice-indicator" style="display:none;"></div>
              <div id="AwayMessageSelector_statusList_icon_vacation"
                   class="AwayMessageSelector_statusList_icon fa-solid fa-plane-departure vacation-indicator" style="display:none;"></div>
              <div class="AwayMessageSelector_statusList_label">{messageType ?? 'Available'}</div>
              <div class="AwayMessageSelector_statusList_arrow fa-solid fa-caret-down"></div>
            </div>
          </div>
          <div id="AwayMessageSelector_anchor"></div>
          <div id="AwayMessageSelector_statusModal" class="AwayMessageSelector_statusModal">
            <div class="AwayMessageSelector_modalTop">
              <h5>Set Your Status</h5>
              <form id="AwayMessageSelector_form">
                <div class="AwayMessageSelector_statusMenuItems">
                  <div class="AwayMessageSelector_statusMenuItem">
                    <input onchange={this.shiftAwayOptions.bind(this)} type="radio"
                           id="AwayMessageSelector_Item_available"
                           name="AwayMessageSelector_input"
                           value="available" defaultChecked={messageType === 'Available'}/>
                    <div class="icon fa-regular fa-circle-check"></div>
                    <label htmlFor="AwayMessageSelector_Item_available">Available</label>
                  </div>
                  <div class="AwayMessageSelector_statusMenuItem">
                    <input onchange={this.shiftAwayOptions.bind(this)} type="radio" id="AwayMessageSelector_Item_away"
                           name="AwayMessageSelector_input"
                           value="away" defaultChecked={messageType === 'Away'}/>
                    <div class="icon fa-regular fa-hourglass-start"></div>
                    <label htmlFor="AwayMessageSelector_Item_away">Away</label></div>
                  <div id="AwayMessageSelector_Item_away_options"></div>
                  <div class="AwayMessageSelector_statusMenuItem">
                    <input onchange={this.shiftAwayOptions.bind(this)} type="radio"
                           id="AwayMessageSelector_Item_outofoffice"
                           name="AwayMessageSelector_input"
                           value="outofoffice" defaultChecked={messageType === 'Out of Office'}/>
                    <div class="icon fa-regular fa-calendar-minus"></div>
                    <label htmlFor="AwayMessageSelector_Item_outofoffice">Out of Office</label></div>
                  <div id="AwayMessageSelector_Item_outofoffice_options"></div>
                  <div class="AwayMessageSelector_statusMenuItem">
                    <input onchange={this.shiftAwayOptions.bind(this)} type="radio"
                           id="AwayMessageSelector_Item_vacation"
                           name="AwayMessageSelector_input"
                           value="vacation" defaultChecked={messageType === 'On Vacation'}/>
                    <div class="icon fa-regular fa-plane-departure"></div>
                    <label htmlFor="AwayMessageSelector_Item_vacation">On Vacation</label></div>
                  <div id="AwayMessageSelector_Item_vacation_options"></div>
                </div>
                <div id="AwayMessageSelector_resetAfter">
                  <div class="AwayMessageSelector_resetAfter_label">Reset Status after:</div>
                  <div class="AwayMessageSelector_resetAfter_wrapper"><select
                    onchange={this.resetAfterChange.bind(this)} id="AwayMessageSelector_resetAfter_select"
                    name="resetAfter" defaultValue={this.state.expiresType === 'none' ? '30mins' : this.state.expiresType}>
                    <option value="30mins">30 mins</option>
                    <option value="1hour">1 hour</option>
                    <option value="2hours">2 hour</option>
                    <option value="today">Today</option>
                    <option value="week">This Week</option>
                    <option value="custom">Custom</option>
                  </select></div>
                  <div id="AwayMessageSelector_resetAfter_customSelector">
                    <div class="AwayMessageSelector_datePicker">
                      <div class="AwayMessageSelector_datePickerDate">
                        <input id="AwayMessageSelector_resetAfter_datetime"
                               type="datetime-local"
                               min={todaysDate} value={this.state.customDate}/></div>
                      <div class={customError}><div class="error-icon fa-regular fa-triangle-exclamation"></div> {this.state.futureError}</div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="AwayMessageSelector_modalBottom">
              <button onclick={this.cancelButtonEventHandler.bind(this)}
                      class="AwayMessageSelector_cancel button button-secondary">Cancel
              </button>
              <button onclick={this.applyButtonEventHandler.bind(this)}
                      class="AwayMessageSelector_apply button button-primary">Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  shiftAwayOptions(e) {
    let element = e.srcElement;
    let resetAfterContainer = $('#AwayMessageSelector_resetAfter');
    switch (element.value) {
      case 'available':
        resetAfterContainer.hide();
        break;
      default:
        resetAfterContainer.detach();
        $('#AwayMessageSelector_Item_' + element.value + '_options').append(resetAfterContainer);
        resetAfterContainer.show();
        break;
    }

    $('input[name=AwayMessageSelector_input] + .icon').removeClass('fa-solid').addClass('fa-regular');
    $('input[name=AwayMessageSelector_input]:checked + .icon').removeClass('fa-regular').addClass('fa-solid');
  }

  toggleModal() {
    const statusModal = $('#AwayMessageSelector_statusModal');
    statusModal.toggle();
    const arrow = $('.AwayMessageSelector_statusList_arrow');
    if (statusModal.is(':visible')) {
      arrow.addClass(['fa-caret-up']).removeClass('fa-caret-down');
      // Show the "Reset Status After" container under the currently selected item
      const e = {
        srcElement: document.querySelector('input[name="AwayMessageSelector_input"]:checked')
      };
      this.shiftAwayOptions(e);
      $('.AwayMessageSelector_statusList').addClass('selected');
    } else {
      arrow.addClass(['fa-caret-down']).removeClass('fa-caret-up');
      $('.AwayMessageSelector_statusList').removeClass('selected');
    }

  }

  hideStatusModal() {
    const statusModal = $('#AwayMessageSelector_statusModal');
    statusModal.hide();
    let arrow = $('.AwayMessageSelector_statusList_arrow');
    arrow.addClass(['fa-caret-down']).removeClass('fa-caret-up');
  }

  resetAfterChange(e) {
    const element = e.srcElement;
    let customSelector = $('#AwayMessageSelector_resetAfter_customSelector');

    if (element.value === 'custom') {
      customSelector.show();
    } else {
      customSelector.hide();
    }
  }

  async refreshCurrentAwayMessage() {
    const jwt = getJwtCookie();
    const response = await fetch(urls.getBaseUrl('accounts') + '/api/v2/away-messages', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${jwt}`
      }
    });
    let data = Object.values(await response.json());
    this.state.myAwayMessage = data[0] ?? [];
    this.state.messageType = data[0]?.message_type ?? 'available';
    this.state.customDate = data[0]?.expires === 0 ? new Date().toISOString().substring(0, 10) + 'T' + this.getDefaultTime() : data[0].expires?.replace(/\+.*$/, '');
    this.state.expiresType = data[0].expires_type ?? '30mins';

    // Normally we'd do this in the main template body but in this case redraw happens asynchronously, and we need
    // the value settled before resetAfterChange is called
    const selectElement = document.getElementById('AwayMessageSelector_resetAfter_select')
    selectElement.value = this.state.expiresType;

    const oEvent = {srcElement: selectElement};
    this.resetAfterChange(oEvent);

    $('.AwayMessageSelector_statusList_icon').hide();
    $(`#AwayMessageSelector_statusList_icon_${this.state.messageType}`).show();
    this.state.isLoaded = true;

    m.redraw();
  }

  applyButtonEventHandler(e) {
    const messageType = $('input[name=AwayMessageSelector_input]:checked').val();
    if (messageType === 'available') {
      this.removeAwayMessage(function () {
        this.hideStatusModal();
        this.refreshCurrentAwayMessage();
      }.bind(this));
      return;
    }

    const expiresType = $('#AwayMessageSelector_resetAfter_select').val();
    let message = {
      message_type: messageType,
      expires_type: expiresType,
    }
    if (expiresType === 'custom') {
      // aggregate expires date, time and timezone
      const expires = $('#AwayMessageSelector_resetAfter_datetime').val();
      const expiresDate = new Date(expires);
      const todaysDate = new Date();

      if (expiresDate >= todaysDate) {
        message.expires = expires;
        this.state.futureError = null;
      }
      else {
        // show error message
        this.state.futureError = 'Select a date and/or time in the future.';
        m.redraw();
        return;
      }
    }
    message.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // noinspection JSIgnoredPromiseFromCall
    this.saveAwayMessage(message, function () {
      this.hideStatusModal();
      // noinspection JSIgnoredPromiseFromCall
      this.refreshCurrentAwayMessage();
    }.bind(this));
  }

  cancelButtonEventHandler(e) {
    this.hideStatusModal();
  }

  async saveAwayMessage(message, callback) {
    const jwt = getJwtCookie();
    try {
      await fetch(urls.getBaseUrl('accounts') + '/api/v2/away-messages', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${jwt}`,
        },
        body: JSON.stringify(message)
      });
      callback();
    } catch (e) {
      console.error('Error:' + e);
    }
  }

  async removeAwayMessage(callback) {
    const jwt = getJwtCookie();
    const apiPath = '/api/v2/away-messages';
    try {
      await fetch(urls.getBaseUrl('accounts') + apiPath, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${jwt}`,
        }
      });
      callback();
    } catch (e) {
      console.error(e);
    }
  }

  enableTooltipIcon(e) {
    $('#AwayMessageSelector_regularIcon').hide();
    $('#AwayMessageSelector_solidIcon').show();
  }

  disableTooltipIcon(e) {
    $('#AwayMessageSelector_regularIcon').show();
    $('#AwayMessageSelector_solidIcon').hide();
  }

  getDefaultTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    if (minutes >= 30) {
      hours += 1;
      minutes = "00";
    } else {
      minutes = "30";
    }

    if (hours >= 24) {
      hours = 0;
    }

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }
}
